/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'success': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="#0C6" stroke-width="2" _fill="none" fill-rule="evenodd"><circle pid="0" cx="16" cy="16" r="15"/><path pid="1" stroke-linejoin="round" d="M9.5 17l3.5 3.5 9.5-9.5"/></g>'
  }
})
